import { get, isEmpty } from 'lodash';
import React from 'react';
import { getParagraphOne } from '../../../common/helpers/ui/dataFilter';
import { handleImageUrl } from '../../../common/helpers/sharpie/imageUrlHelper';
import { generateContentPageTitle } from '../../../common/helpers/ui/pageTitleMetaDescription';
import SeoHeader from '../../seoHeader/SeoHeader';

const SEO_IMAGE_WIDTH = 1200;
const SEO_IMAGE_HEIGHT = 630;

interface SEO {
  metadesc?: string;
}

interface FeaturedImage {
  url?: string;
}
interface Post {
  seo?: SEO;
  title?: string;
  featuredImage?: FeaturedImage;
  content?: string;
}
interface ContentSeoHeaderprops {
  post?: Post;
  canonicalLink?: string;
}

const ContentSeoHeader: React.FC<ContentSeoHeaderprops> = ({
  post = {},
  canonicalLink,
}) => {
  const { seo = {}, title, featuredImage, content = '' } = post;
  const seoTitle = generateContentPageTitle(title);
  const sharpieImgUri = handleImageUrl(
    get(featuredImage, 'url'),
    SEO_IMAGE_WIDTH,
    SEO_IMAGE_HEIGHT,
  );
  const description = !isEmpty(seo.metadesc)
    ? seo.metadesc
    : getParagraphOne(content);

  return (
    <SeoHeader
      title={seoTitle}
      description={description}
      canonicalLink={canonicalLink}
      imageUrl={sharpieImgUri}
      ogType="article"
    />
  );
};

export default ContentSeoHeader;
